export default function fetchRecipeInfo(ids) {
  let arr = []
  
  ids.forEach(id => {
    let intro;
  
    try {
      // get intro.js file for given id
      // it gets imported as a module, which has an 'intro' property
      intro = require(`../recipes/${id}/intro`).intro;
    } catch (error) {
      console.error(`Failed to load intro for recipe with id ${id}:`, error);
      return;
    }

    // get video if it exists
    const video = intro.media.find(item => item.endsWith('.mp4'));
    // get image (either first image, or thumbnail that corresponds to video)
    const image = video && intro.thumbnails
      ? intro.thumbnails[video.split('.')[0]]
      : intro.media.find(item => item.endsWith('.jpg'));

    arr.push({
      linkTo: intro.id,
      image: image,
      ...(video ? { video: video } : {}),
      title: intro.title,
      description: intro.description,
      label: intro.author
    })
  })

  return arr;
}